import { render, staticRenderFns } from "./OrderResume.vue?vue&type=template&id=3d6b08c1"
import script from "./OrderResume.vue?vue&type=script&lang=js"
export * from "./OrderResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports